import { PadBox } from '@bedrock-layout/padbox';
import styled from 'styled-components';

export const CodeContainer = styled(PadBox)`
  block-size: 65rem;
`;
